import { Box } from "@mui/material";
import { useState, useEffect } from "react";
import { useGlobalAuthContext } from "../context/AuthContext";
import PartnersTable from "../Components/Partners/PartnersTable";
import { useGetPackagesQuery, usePartnersQuery } from "../Slices/roomNateApis";
import PartnerDetail from "../Components/Partners/PartnerDetail";
import { useGlobalContext } from "../context/GlobalContext";

const Partners = () => {
  const { activePartner } = useGlobalContext();

  const { currentUserSessionStorage } = useGlobalAuthContext();

  const [selectedPartner, setSelectedPartner] = useState(null);

  const { data: partnersData, isLoading: partnersLoading, error: partnersError } = usePartnersQuery(activePartner, {
    skip: !currentUserSessionStorage,
  });

  const { data: pacakgesData, isLoading: packagesLoading, error: packagesError } = useGetPackagesQuery("", {
    skip: !currentUserSessionStorage,
  });

  // DEBUG: Log API responses to diagnose data issues (dev only)
  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      console.log('[Partners Page] 🔍 DEBUG - activePartner filter:', activePartner);
      console.log('[Partners Page] 🔍 DEBUG - partnersData:', partnersData);
      console.log('[Partners Page] 🔍 DEBUG - partnersLoading:', partnersLoading);
      console.log('[Partners Page] 🔍 DEBUG - partnersError:', partnersError);
      console.log('[Partners Page] 🔍 DEBUG - pacakgesData:', pacakgesData);
      console.log('[Partners Page] 🔍 DEBUG - packagesLoading:', packagesLoading);
      console.log('[Partners Page] 🔍 DEBUG - packagesError:', packagesError);
    }
  }, [partnersData, partnersLoading, partnersError, pacakgesData, packagesLoading, packagesError, activePartner]);

  if (selectedPartner)
    return (
      <PartnerDetail
        key={selectedPartner._id}
        partner={selectedPartner}
        packages={pacakgesData}
        onBack={() => setSelectedPartner(null)}
      />
    );

  return (
    <Box>

      
      <PartnersTable
        partnersData={partnersData}
        setSelectedPartner={setSelectedPartner}
        packages={pacakgesData}
      />
    </Box>
  );
};

export default Partners;
